"use client";

import { useEffect } from "react"
import { useRouter } from "next/navigation"
import { useSession } from "next-auth/react"

export default function HomePage() {
  const router = useRouter();
  const { data: session, status } = useSession();

  useEffect(() => {
    // Only redirect if we have a session or if auth is not required
    // This prevents redirect loops when authentication is in progress
    if (status === 'authenticated' || status === 'unauthenticated') {
      // Small delay to ensure middleware has processed
      const timer = setTimeout(() => {
        router.replace('/clients');
      }, 100);
      return () => clearTimeout(timer);
    }
  }, [router, status]);

  // Show loading while redirecting or checking auth
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-4"></div>
        <p className="text-muted-foreground">
          {status === 'loading' ? 'Loading...' : 'Redirecting to clients...'}
        </p>
      </div>
    </div>
  );
}